import { ScoreDetailChartBox } from "src/components/ScoreDetail/Chart";
import { ChartMode, ScoreDetailChartData } from "src/components/ScoreDetail/Chart/chart.types";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";
import { SummaryData } from "src/context/ScoreDetail/ScoreDetailBuilder";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";

type SummaryDetailProps = {
    summary: SummaryData;
    mode: ChartMode;
    detailIndex: number;
};
export const SummaryDetail = (props: SummaryDetailProps) => {
    const { summary, mode, detailIndex } = props;
    const { scoreList } = useScoreDetailContext();

    const summaryItem = summary.summary?.[detailIndex];
    if (summaryItem === undefined) {
        console.error(`Unexpected Error in SummaryDetail`);
        return null;
    }
    const detailItem = summary.detail?.[summaryItem.id];
    if (detailItem === undefined) {
        console.error(`Unexpected Error in SummaryDetail 2`);
        return null;
    }

    const data: ScoreDetailChartData[] = detailItem.map((item) => {
        return {
            score: ScoreService.normalizeScore(item.score, scoreList.lastSelected.precision),
            title: item.label,

            // No drilldown in SummaryDetail.
            // But maybe we'll have to think about a redirect feature.
            // Here, instead of action, driving the drilldown
            // We could have a redirectToUrl feature,
            // properly handled in terms of navigation for accessibility,
            // And therefore, the other items in Distribution would link to their
            // next URL
            // And here, we'd be able to automatically redirect outside of Distribution.

            // Maybe we want here to redirect outside with navigate WAITING FOR GLOBAL NAV ?
            action: undefined,
        };
    });

    const total: ScoreDetailChartData = {
        title: "total",
        score: ScoreService.normalizeScore(summaryItem.score, scoreList.lastSelected.precision),
    };
    return <ScoreDetailChartBox data={data} total={total} mode={mode} />;
};
